import React, { PropTypes } from 'react';
import moment from 'moment';
import Tooltip from 'react-tooltip';
import { v4 } from 'node-uuid';
import { isMobile } from 'common/utils';

const TimeWithTooltip = ({
  time, format="fromNow", tooltipFormat="MMMM D, YYYY hh:mm a", className
}) => {
  const uuid = v4();
  let timeStr = "";
  if (format === "fromNow") {
    timeStr = moment(time).fromNow();
  }

  return (
    <span
      className={className}
      data-tip={true}
      data-for={uuid}
      data-event={isMobile()? "click" : undefined}
    >
      { timeStr }
      <Tooltip class="tooltip" effect="solid" id={uuid}>
        { moment(time).format(tooltipFormat) }
      </Tooltip>
    </span>
  );
}

TimeWithTooltip.propTypes = {
  time: PropTypes.string.isRequired,
  format: PropTypes.string,
  tooltipFormat: PropTypes.string,
  className: PropTypes.string,
};

export default TimeWithTooltip;
